
import { Grid, Typography } from '@material-ui/core';
import { GridColumns } from '@material-ui/data-grid';
import { SummaryProps } from '../../../Interfaces/Interfaces';
import Table from '../../Table/Table';

const Summary = (props: SummaryProps) => {
	const { blueCoalitionDetails, redCoalitionDetails } = props;

	const headers:GridColumns = [
		{ field: "vehicule", headerName: "Vehicle", flex: 1, headerAlign: "left", align: "left" },
		{ field: "quantity", headerName: "Quantity", flex: 1, headerAlign: "center", align: "center" },
	]

	return (
		<Grid container justify="space-between" spacing={4}>
			<Grid
				item
				xs={12}
				sm={6}
			>
				<Grid container>
					<Grid item xs={12}>
						<Typography variant="h4" align="center" style={{ color: "blue" }}> Blue Coalition </Typography>
					</Grid>
					<Grid item xs={12}>
						<Table rows={blueCoalitionDetails ? blueCoalitionDetails : null} columns={headers} editTable={false}/>
					</Grid>
				</Grid>
			</Grid>
			<Grid
				item
				xs={12}
				sm={6}
			>
				<Grid container>
					<Grid item xs={12}>
						<Typography variant="h4" align="center" style={{ color: "red" }}> Red Coalition </Typography>
					</Grid>
					<Grid item xs={12}>
						<Table rows={redCoalitionDetails ? redCoalitionDetails : null} columns={headers} editTable={false}/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>

	)
}
export default Summary ;
